export const dataURLtoBlob = (dataurl: string) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)![1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const sortFilterToOrderByKey = (sortFilter: string) => {
  switch (sortFilter) {
    case "Created At: Latest":
    case "Created At: Earliest":
      return "created_at";
    case "Price: High to low":
    case "Price: Low to high":
      return "price";
    case "Name: A to Z":
    case "Name: Z to A":
      return "name";
    default:
      return "created_at";
  }
};

export const sortFilterToOrderByValue = (sortFilter: string) => {
  switch (sortFilter) {
    case "Created At: Latest":
    case "Name: Z to A":
    case "Price: High to low":
      return "DESC";
    case "Created At: Earliest":
    case "Name: A to Z":
    case "Price: Low to high":
      return "ASC";
    default:
      return "DESC";
  }
};

// Map of platform keys to their display names
const platformDisplayNames: Record<string, string> = {
  facebookAds: "Facebook Ads",
  instagramAds: "Instagram Ads",
  tiktokAds: "TikTok Ads",
  googleAds: "Google Ads",
  linkedinAds: "LinkedIn Ads",
  snapchatAds: "Snapchat Ads",
  redditAds: "Reddit Ads",
  xAds: "X Ads",
  youtubeAds: "YouTube Ads",
};

/**
 * Transforms a platform key into its display name
 * @param platformKey - The camelCase platform key (e.g., "facebookAds")
 * @returns The formatted display name (e.g., "Facebook Ads")
 */
export const getPlatformDisplayName = (platformKey: string): string => {
  // Check if we have a predefined display name
  if (platformKey in platformDisplayNames) {
    return platformDisplayNames[platformKey];
  }

  // Fallback transformation for unknown platforms
  return (
    platformKey
      // Split on camelCase
      .replace(/([A-Z])/g, " $1")
      // Handle special cases like "TikTok"
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // Capitalize first letter
      .replace(/^./, (str) => str.toUpperCase())
      // Clean up any extra spaces
      .trim()
  );
};

/**
 * Transforms multiple platform keys into an array of display names
 * @param platformKeys - Array of platform keys
 * @returns Array of formatted display names
 */
export const getPlatformDisplayNames = (platformKeys: string[]): string[] => {
  return platformKeys.map(getPlatformDisplayName);
};

/**
 * Get platform color class for visual styling
 * @param platformKey - The platform key
 * @returns Tailwind CSS color class
 */
export const getPlatformColorClass = (platformKey: string): string => {
  const colorMap: Record<string, string> = {
    facebookAds: "bg-blue-100 text-blue-800",
    instagramAds: "bg-pink-100 text-pink-800",
    tiktokAds: "bg-gray-100 text-gray-800",
    googleAds: "bg-red-100 text-red-800",
    linkedinAds: "bg-blue-100 text-blue-800",
    snapchatAds: "bg-yellow-100 text-yellow-800",
    redditAds: "bg-orange-100 text-orange-800",
    xAds: "bg-gray-100 text-gray-800",
    youtubeAds: "bg-red-100 text-red-800",
  };

  return colorMap[platformKey] || "bg-gray-100 text-gray-800";
};

// Example testing code:
/* 
console.log(getPlatformDisplayName("facebookAds")); // "Facebook Ads"
console.log(getPlatformDisplayName("tiktokAds")); // "TikTok Ads"
console.log(getPlatformDisplayName("someNewPlatformAds")); // "Some New Platform Ads"
*/
